import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import Routes from './components/Routes';
import { AuthProvider } from './utils/AuthContext';
import { SearchProvider } from './utils/SearchContext';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SearchProvider>
        <AuthProvider>
          <Routes />
        </AuthProvider>
      </SearchProvider>
    </QueryClientProvider>
  );
}

export default App;
